<button [disabled]="disabled" type="button" tabindex="-1" class="btn btn-sm btn-link p-0 align-left {{class}}" style="{{style}}"
   placement="bottom" container="body" [ngbTooltip]="tooltip" (click)="click();$event.stopPropagation();">
   {{caption}}<span *ngIf="showIcon">&nbsp;&nbsp;<i class="{{iconClass}}"></i></span>
   <ng-content></ng-content>
</button>
